import axios, { AxiosInstance } from 'axios'
import { createAxiosInstance } from './axiosBase'

export const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL || 'https://referal-api.aishka.ai/'

export const instance: AxiosInstance = axios.create({
  baseURL: REACT_APP_BASE_URL,
})

/**
 * Кастомный экземпляр Axios для запросов на бекэнд рефералки.
 */
export const referralSecureApi = createAxiosInstance({
  baseUrl: REACT_APP_BASE_URL,
  useAuth: true,
})
